import React, { useEffect, useState, useContext, useRef } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import CreateCollectionModal from "pages/de/collection/components/CreateCollectionModal";

const EmptyCollectionRecord = ({ content = null, refresh = () => {}, size = "md" }) => {
  const [createCollectionVisible, setCreateCollectionVisible] = useState(false);

  const navigate = useNavigate();

  const handleAfterOk = (newCollection) => {
    let id = newCollection?.data?.collection?.id;
    if (id) {
      navigate(`/workspace/collections?id=${id}`);
    }
  };

  return (
    <SuiBox sx={{ my: 2, mx: 1 }}>
      <SuiBox
        sx={{
          border: "1px dashed",
          borderWidth: ({ borders }) => borders.borderWidth[2],
          borderColor: ({ borders }) => borders.borderColor,
          cursor: "pointer",
          height: 120,
          width: "100%",
          borderRadius: 4,
        }}
      >
        {content ? (
          content
        ) : (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ height: "100%", width: "100%" }}
            onClick={() => setCreateCollectionVisible(true)}
          >
            <AddIcon fontSize="small" />
            <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
              Create Collection
            </SuiTypography>{" "}
          </SuiBox>
        )}
      </SuiBox>
      {createCollectionVisible ? (
        <CreateCollectionModal
          handleClose={() => setCreateCollectionVisible(false)}
          visible={createCollectionVisible}
          isEdit={false}
          handleAfterOk={handleAfterOk}
          handleRefresh={refresh}
        />
      ) : null}
    </SuiBox>
  );
};

export default EmptyCollectionRecord;
